import { useEffect, useState } from 'react';

export const generateUniqueKey = () => Date.now().valueOf();

export const useComponentRefreshKey = (dependency, { delay = 500 } = {}) => {
    const [key, setKey] = useState(generateUniqueKey());

    useEffect(() => {
        const tm = setTimeout(() => setKey(generateUniqueKey()), delay);
        return () => clearTimeout(tm);
    }, [dependency, delay]);

    return key;
};

export function removeArrayItem(arr, index) {
    const newArr = [...arr];
    newArr.splice(index, 1);
    return newArr;
}

export function findRecursive(items, searchKey, keyProp = 'key', subItemsProp = 'children') {
    let foundItem;

    for (const item of items) {
        const subItems = item[subItemsProp];
        if (item[keyProp] === searchKey) {
            foundItem = item;
            break;
        } else if (subItems?.length) {
            const _found = findRecursive(subItems, searchKey, keyProp, subItemsProp);
            if (_found) {
                foundItem = _found;
                break;
            }
        }
    }

    return foundItem;
}
